import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { QuickScheduleForm } from './types';

// Hook to auto-progress when producer is selected
export function useAutoProgressOnProducer(onNext?: () => void) {
  const formikContext = useFormikContext<QuickScheduleForm>();
  const initialProducerRef = useRef<string | undefined>(
    formikContext?.values?.requesterContactInformation?.producer,
  );
  const hasAutoProgressed = useRef(false);

  useEffect(() => {
    if (!onNext || !formikContext) return;

    const { values } = formikContext;
    // Only use producer ID for auto-progress, not first_name
    // This prevents auto-progress when typing in "add new producer" form
    const currentProducerId = values?.requesterContactInformation?.producer;

    // Only auto-progress if:
    // 1. A producer ID is selected from dropdown (not manual entry)
    // 2. It's different from the initial value (user made a change)
    // 3. We haven't already auto-progressed
    if (
      currentProducerId &&
      currentProducerId !== initialProducerRef.current &&
      !hasAutoProgressed.current
    ) {
      hasAutoProgressed.current = true;
      setTimeout(() => onNext(), 300);
    }
  }, [
    formikContext?.values?.requesterContactInformation?.producer,
    onNext,
    formikContext,
  ]);
}

// Hook to auto-progress when block is selected
export function useAutoProgressOnBlock(onNext?: () => void) {
  const formikContext = useFormikContext<QuickScheduleForm>();
  const previousBlockTitle = useRef(formikContext?.values?.blockTitle);

  useEffect(() => {
    if (!onNext || !formikContext) return;

    const { values } = formikContext;
    if (
      values?.blockTitle &&
      values.blockTitle !== previousBlockTitle.current
    ) {
      previousBlockTitle.current = values.blockTitle;
      setTimeout(() => onNext(), 400);
    }
  }, [formikContext?.values?.blockTitle, onNext, formikContext]);
}
